import { format, subMonths } from 'date-fns'

const thisMonth = format(new Date(), 'yyyy-MM')
const lastMonth = format(subMonths(new Date(), 1), 'yyyy-MM')

export default {
  total_usage_over_time_summary: [
    { category: 'lessons', event_count: 3, student_count: 2 },
    { category: 'quizzes', event_count: 3, student_count: 2 },
    { category: 'assessments', event_count: 3, student_count: 2 },
    { category: 'books', event_count: 3, student_count: 2 },
    { category: 'spelling', event_count: 3, student_count: 2 },
  ],
  total_usage_over_time_by_month: [
    {
      category: 'lessons',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'quizzes',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'assessments',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'books',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'spelling',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
  ],
}
